/* ==========================================================================
   FUNCTNL — BUY ZONE
   Behaviour for sections/fn-buy-zone.liquid: gallery, pack and purchase-type
   selection, quantity, add to cart, accordions, customer videos, the
   percentage bars and the nutrition pop-up.

   Each section renders one <fn-buy-zone> element, so when the theme editor
   re-renders a section the new element initialises itself.
   ========================================================================== */
(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('fn-buy-zone')) return;

  var EASE = 'cubic-bezier(.4,0,.2,1)';

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function decodeEntities(str) {
    var t = document.createElement('textarea');
    t.innerHTML = str;
    return t.value;
  }

  /* Shopify money formats: {{amount}}, {{amount_no_decimals}}, {{amount_with_comma_separator}} ... */
  function formatMoney(cents, format) {
    var fmt = decodeEntities(String(format || '£{{amount}}').replace(/<[^>]*>/g, ''));
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    function delimit(n, precision, thousands, decimal) {
      if (isNaN(n) || n === null) return '0';
      var parts = (n / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return match ? fmt.replace(match[0], value) : value;
  }

  class FnBuyZone extends HTMLElement {
    connectedCallback() {
      if (!this.bound) this.setup();
      /* The pop-ups live on <body> so no transformed ancestor can trap them. */
      this.modals.forEach(function (m) { document.body.appendChild(m.el); });
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      (this.modals || []).forEach(function (m) {
        m.hide(true);
        if (m.home) m.home.appendChild(m.el);
      });
    }

    setup() {
      this.bound = true;
      this.modals = [];
      this.onBlockSelect = this.onBlockSelect.bind(this);

      var json = this.querySelector('[data-fnb-json]');
      try { this.data = JSON.parse(json.textContent); } catch (e) { this.data = {}; }
      var d = this.data;
      d.plans = d.plans || [];
      d.variants = d.variants || [];

      var startId = Number(this.getAttribute('data-variant-id'));
      var variant = d.variants.filter(function (v) { return v.id === startId; })[0] || d.variants[0] || null;
      var planSelect = this.querySelector('[data-fnb-plan-select]');
      var initialPlan = Number(this.getAttribute('data-initial-plan')) || null;

      this.state = {
        qty: 1,
        variant: variant,
        options: variant ? variant.options.slice() : [],
        mode: initialPlan ? 'sub' : 'once',
        plan: planSelect ? Number(planSelect.value) : (initialPlan || (d.plans[0] ? d.plans[0].id : null))
      };

      var price = this.querySelector('[data-fnb-price]');
      this.cfg = {
        showCompare: price ? price.getAttribute('data-show-compare') === 'true' : true,
        subCompare: price ? price.getAttribute('data-sub-compare') === 'true' : false,
        multiply: price ? price.getAttribute('data-multiply') === 'true' : true,
        manual: (price ? price.getAttribute('data-manual-compare') || '' : '').split(',').reduce(function (m, pair) {
          var kv = pair.split(':');
          if (kv.length === 2 && kv[1]) m[kv[0]] = Number(kv[1]);
          return m;
        }, {})
      };

      var qtyGroup = this.querySelector('[data-fnb-qty-group]');
      this.maxQty = qtyGroup ? (Number(qtyGroup.getAttribute('data-max')) || 99) : 99;
      this.form = this.querySelector('[data-fnb-form]');

      this.bindControls();
      this.initGallery();
      this.initAccordions();
      this.initVideos();
      this.initBars();
      this.initModals();
      this.initFitText();
      this.render();
    }

    /* ---- one-line title ---------------------------------------------------
       CSS sizes the title against the column width, but how long the line
       ends up depends on the font actually loaded (the theme's heading font is
       wider than the Archivo fallback). Measure and shrink to fit whenever the
       fonts finish loading or the column changes width. */
    initFitText() {
      var items = Array.prototype.slice.call(this.querySelectorAll('.fnb-title--fit, .fnb-sub--fit'));
      if (!items.length) return;
      var frame = 0;
      var fit = function () {
        frame = 0;
        items.forEach(function (el) {
          el.style.fontSize = '';
          var available = el.clientWidth;
          var needed = el.scrollWidth;
          if (available > 0 && needed > available) {
            var size = parseFloat(window.getComputedStyle(el).fontSize);
            el.style.fontSize = Math.floor(size * (available / needed) * 100) / 100 + 'px';
          }
        });
      };
      var schedule = function () { if (!frame) frame = window.requestAnimationFrame(fit); };
      fit();
      if (document.fonts) {
        if (document.fonts.ready) document.fonts.ready.then(schedule);
        document.fonts.addEventListener('loadingdone', schedule);
      }
      if (window.ResizeObserver) {
        new ResizeObserver(schedule).observe(this.querySelector('.fnb-info') || this);
      }
    }

    /* ---- selection ------------------------------------------------------- */
    bindControls() {
      var self = this;

      this.querySelectorAll('[data-fnb-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var next = self.state.qty + Number(btn.getAttribute('data-fnb-qty'));
          if (next < 1 || next > self.maxQty) return;
          self.state.qty = next;
          self.render();
        });
      });

      this.querySelectorAll('[data-fnb-option]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.selectOption(Number(btn.getAttribute('data-fnb-option')), btn.getAttribute('data-value'));
        });
      });

      this.querySelectorAll('[data-fnb-mode]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var changed = self.state.mode !== btn.getAttribute('data-fnb-mode');
          self.state.mode = btn.getAttribute('data-fnb-mode');
          self.render();
          if (changed) self.afterChange();
        });
      });

      var planSelect = this.querySelector('[data-fnb-plan-select]');
      if (planSelect) {
        planSelect.addEventListener('change', function () {
          self.state.plan = Number(planSelect.value);
          self.render();
          self.afterChange();
        });
      }

      /* Radio groups (pack sizes, purchase type): arrow keys, Home and End move
         the selection, and only the selected option is in the tab order. */
      this.querySelectorAll('[role="radiogroup"]').forEach(function (group) {
        group.addEventListener('keydown', function (e) {
          var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
          if (!step && e.key !== 'Home' && e.key !== 'End') return;
          var radios = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]'));
          var i = radios.indexOf(document.activeElement);
          if (i < 0) return;
          e.preventDefault();
          var next = e.key === 'Home' ? 0 : e.key === 'End' ? radios.length - 1 : (i + step + radios.length) % radios.length;
          radios[next].click();
          radios[next].focus();
        });
      });

      if (this.form) this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
    }

    selectOption(index, value) {
      var opts = this.state.options.slice();
      opts[index] = value;
      var variants = this.data.variants;
      var match =
        variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0] ||
        variants.filter(function (v) { return v.options[index] === value && v.available; })[0] ||
        variants.filter(function (v) { return v.options[index] === value; })[0];
      if (!match) return;

      var changed = match !== this.state.variant;
      this.state.options = match.options.slice();
      this.state.variant = match;
      this.render();
      if (!changed) return;

      this.syncGallery(match);
      this.dispatchEvent(new CustomEvent('fnb:variant-change', { bubbles: true, detail: { variant: match } }));
      this.afterChange();
    }

    /* After a shopper changes pack, purchase type or plan: keep the URL
       shareable (?variant=&selling_plan=, which Shopify reads on load) and
       announce the selection for any integration that wants it. */
    afterChange() {
      var v = this.state.variant;
      if (!v) return;
      if (this.getAttribute('data-update-url') === 'true' && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        if (this.currentPlanId) url.searchParams.set('selling_plan', this.currentPlanId);
        else url.searchParams.delete('selling_plan');
        window.history.replaceState(window.history.state, '', url.toString());
      }
      this.dispatchEvent(new CustomEvent('fnb:purchase-change', {
        bubbles: true,
        detail: { variantId: v.id, sellingPlanId: this.currentPlanId || null, quantity: this.state.qty }
      }));
    }

    render() {
      var self = this, d = this.data, s = this.state, v = s.variant, cfg = this.cfg;
      if (!v) return;
      var money = function (c) { return formatMoney(c, d.moneyFormat); };

      var planId = null;
      if (d.plans.length && (s.mode === 'sub' || d.requiresPlan)) {
        planId = s.plan || d.plans[0].id;
        if (!v.plans || !v.plans[String(planId)]) planId = null;
      }
      this.currentPlanId = planId;
      this.toggleAttribute('data-fnb-sub', !!planId);
      var alloc = planId ? v.plans[String(planId)] : null;
      var mult = cfg.multiply ? s.qty : 1;
      var unit = alloc ? alloc.price : v.price;
      var was = alloc ? (cfg.subCompare ? v.price : alloc.compareAt) : (v.compareAt > v.price ? v.compareAt : (cfg.manual[String(v.id)] || 0));
      var total = unit * mult;
      var servings = (v.servings || 0) * mult;

      this.querySelectorAll('[data-fnb-price-now]').forEach(function (el) { el.textContent = money(total); });
      this.querySelectorAll('[data-fnb-price-was]').forEach(function (el) {
        var show = cfg.showCompare && was > unit;
        el.hidden = !show;
        el.textContent = show ? money(was * mult) : '';
      });
      this.querySelectorAll('[data-fnb-price-per]').forEach(function (el) {
        var tpl = el.getAttribute('data-template') || '';
        el.hidden = !tpl || !servings;
        if (tpl && servings) {
          el.textContent = tpl.split('[price]').join(money(Math.round(total / servings))).split('[servings]').join(String(servings));
        }
      });
      /* Saving per serving (independent of quantity): against one single pack
         at the one-time price, or against the struck-through price. */
      this.querySelectorAll('[data-fnb-price-save]').forEach(function (el) {
        var tpl = el.getAttribute('data-template') || '';
        var basisPer = 0;
        if (el.getAttribute('data-basis') === 'single') basisPer = d.basePrice / (d.baseServings || 1);
        else if (was > unit && v.servings) basisPer = was / v.servings;
        var saving = v.servings ? Math.round(basisPer - unit / v.servings) : 0;
        el.hidden = !tpl || saving <= 0;
        if (!el.hidden) el.textContent = tpl.split('[saving]').join(money(saving));
      });

      if (this.form) {
        var idInput = this.form.querySelector('[data-fnb-id]');
        var planInput = this.form.querySelector('[data-fnb-plan-input]');
        var qtyInput = this.form.querySelector('[data-fnb-qty-input]');
        if (idInput) idInput.value = v.id;
        if (planInput) { planInput.value = planId || ''; planInput.disabled = !planId; }
        if (qtyInput) qtyInput.value = s.qty;
      }

      this.querySelectorAll('[data-fnb-qty-val]').forEach(function (el) { el.textContent = s.qty; });
      this.querySelectorAll('[data-fnb-qty]').forEach(function (btn) {
        btn.disabled = Number(btn.getAttribute('data-fnb-qty')) < 0 ? s.qty <= 1 : s.qty >= self.maxQty;
      });

      this.querySelectorAll('[data-fnb-atc]').forEach(function (btn) {
        btn.disabled = !v.available;
        var label = btn.querySelector('[data-fnb-atc-label]');
        if (!label || btn.classList.contains('is-added')) return;
        label.textContent = !v.available
          ? btn.getAttribute('data-sold-out')
          : (planId && btn.getAttribute('data-sub-label')) || btn.getAttribute('data-label');
      });

      this.querySelectorAll('[data-fnb-option]').forEach(function (btn) {
        var i = Number(btn.getAttribute('data-fnb-option'));
        btn.setAttribute('aria-checked', s.options[i] === btn.getAttribute('data-value') ? 'true' : 'false');
      });

      this.querySelectorAll('[data-fnb-mode]').forEach(function (btn) {
        var isSub = btn.getAttribute('data-fnb-mode') === 'sub';
        btn.setAttribute('aria-checked', isSub === !!planId ? 'true' : 'false');
      });

      var activeId = s.plan || (d.plans[0] && d.plans[0].id);
      var activePlan = d.plans.filter(function (p) { return p.id === activeId; })[0];
      this.querySelectorAll('[data-fnb-chip]').forEach(function (chip) {
        var pct = activePlan ? Number(activePlan.percent) : 0;
        chip.hidden = !pct;
        if (pct) chip.textContent = (chip.getAttribute('data-template') || '').split('[percent]').join(String(Math.round(pct * 100) / 100));
      });

      this.querySelectorAll('[data-fnb-sub-only]').forEach(function (el) { el.hidden = !planId; });

      this.querySelectorAll('[role="radiogroup"]').forEach(function (group) {
        var radios = group.querySelectorAll('[role="radio"]');
        var checked = group.querySelector('[role="radio"][aria-checked="true"]') || radios[0];
        radios.forEach(function (r) { r.setAttribute('tabindex', r === checked ? '0' : '-1'); });
      });
    }

    /* ---- gallery --------------------------------------------------------- */
    initGallery() {
      var gal = this.querySelector('[data-fnb-gallery]');
      if (!gal) return;
      var main = gal.querySelector('[data-fnb-gal-main]');
      var img = main && main.querySelector('.fnb-gal__img');
      var cap = main && main.querySelector('[data-fnb-gal-cap]');
      var num = main && main.querySelector('[data-fnb-gal-num]');
      var slides = Array.prototype.slice.call(gal.querySelectorAll('.fnb-th'));
      var g = this.gallery = { el: gal, slides: slides, idx: Number(gal.getAttribute('data-start')) || 0, show: function () {} };
      if (!main || !img || !slides.length) return;
      if (slides[g.idx]) img.setAttribute('data-current', slides[g.idx].getAttribute('data-src'));

      g.show = function (i) {
        g.idx = (i + slides.length) % slides.length;
        var t = slides[g.idx];
        slides.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
        var row = t.parentNode;
        if (row && row.scrollWidth > row.clientWidth) row.scrollBy({ left: t.getBoundingClientRect().left - row.getBoundingClientRect().left - (row.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        if (num) num.textContent = g.idx + 1;
        if (cap) {
          cap.textContent = t.getAttribute('data-cap') || '';
          cap.hidden = !t.getAttribute('data-cap');
        }
        var src = t.getAttribute('data-src');
        if (!src || img.getAttribute('data-current') === src) return;
        img.setAttribute('data-current', src);
        main.classList.add('swap');

        var pre = new Image();
        if (img.sizes) pre.sizes = img.sizes;
        pre.onload = function () {
          if (img.getAttribute('data-current') !== src) return;
          img.srcset = t.getAttribute('data-srcset') || '';
          img.src = src;
          img.alt = t.getAttribute('data-alt') || '';
          main.classList.remove('swap');
        };
        pre.onerror = function () { main.classList.remove('swap'); };
        if (t.getAttribute('data-srcset')) pre.srcset = t.getAttribute('data-srcset');
        pre.src = src;
      };

      slides.forEach(function (t, i) { t.addEventListener('click', function () { g.show(i); }); });
      var prev = main.querySelector('[data-fnb-gal-prev]');
      var next = main.querySelector('[data-fnb-gal-next]');
      if (prev) prev.addEventListener('click', function () { g.show(g.idx - 1); });
      if (next) next.addEventListener('click', function () { g.show(g.idx + 1); });
      main.addEventListener('keydown', function (e) {
        if (slides.length < 2) return;
        if (e.key === 'ArrowLeft') g.show(g.idx - 1);
        if (e.key === 'ArrowRight') g.show(g.idx + 1);
      });

      /* Touch swipe. Mouse pointers are ignored so desktop keeps its hover
         arrows; a mostly vertical drag is handed back to the page. */
      if (gal.getAttribute('data-swipe') !== 'true' || slides.length < 2 || !window.PointerEvent) return;
      var reduce = prefersReducedMotion();
      var x0 = 0, y0 = 0, dx = 0, drag = false, axis = null;
      function finish() {
        if (!drag) return;
        drag = false;
        main.classList.remove('dragging');
        img.style.transform = '';
        if (axis === 'x' && Math.abs(dx) > 44) g.show(dx < 0 ? g.idx + 1 : g.idx - 1);
        dx = 0; axis = null;
      }
      main.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') return;
        drag = true; axis = null; dx = 0; x0 = e.clientX; y0 = e.clientY;
      });
      main.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var mx = e.clientX - x0, my = e.clientY - y0;
        if (!axis) {
          if (Math.abs(mx) > Math.abs(my) + 4) axis = 'x';
          else if (Math.abs(my) > 6) { drag = false; return; }
          else return;
        }
        dx = mx;
        main.classList.add('dragging');
        if (!reduce) img.style.transform = 'translate3d(' + (dx * 0.32) + 'px,0,0)';
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) { main.addEventListener(ev, finish); });
    }

    syncGallery(variant) {
      var g = this.gallery;
      if (!g || !variant.mediaId || g.el.getAttribute('data-sync') !== 'true') return;
      for (var i = 0; i < g.slides.length; i++) {
        if (Number(g.slides[i].getAttribute('data-media-id')) === variant.mediaId) { g.show(i); return; }
      }
    }

    /* ---- accordions -------------------------------------------------------
       <details> cannot be transitioned in CSS, so the toggle is taken over and
       the element's own height is animated. Without JS they still open. */
    initAccordions() {
      if (prefersReducedMotion() || typeof Element === 'undefined' || !Element.prototype.animate) return;
      this.querySelectorAll('details.fnb-acc').forEach(function (d) {
        var sum = d.querySelector('summary');
        var body = d.querySelector('.fnb-acc__b');
        var run = null;
        if (!sum || !body) return;
        sum.addEventListener('click', function (e) {
          e.preventDefault();
          if (run) { run.forEach(function (a) { a.cancel(); }); run = null; }
          var from = d.offsetHeight;
          var opening = !d.open;
          d.open = true;
          var to = opening ? d.offsetHeight : sum.offsetHeight;
          var h = d.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: opening ? 300 : 240, easing: EASE });
          var o = body.animate(opening ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 1 }, { opacity: 0 }],
            { duration: opening ? 240 : 160, easing: EASE, delay: opening ? 60 : 0, fill: 'backwards' });
          run = [h, o];
          h.onfinish = function () {
            if (!opening) d.open = false;
            run = null;
          };
        });
      });
    }

    /* ---- customer videos --------------------------------------------------
       A tile only gets a play button when a clip is attached, and the clip is
       only inserted when tapped, so nothing loads up front. */
    initVideos() {
      this.querySelectorAll('[data-fnb-tile]').forEach(function (tile) {
        var tpl = tile.querySelector('template[data-fnb-video]');
        if (!tpl) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fnb-ugc__btn';
        btn.setAttribute('aria-label', tile.getAttribute('data-label') || 'Play video');
        btn.innerHTML = '<span class="fnb-ugc__play"><svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.2v13.6L19 12z"/></svg></span>';
        tile.appendChild(btn);
        btn.addEventListener('click', function () {
          var node = tpl.content.cloneNode(true);
          tile.innerHTML = '';
          tile.appendChild(node);
          var video = tile.querySelector('video');
          if (video) {
            video.controls = true;
            video.playsInline = true;
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          }
        });
      });
    }

    /* ---- percentage bars: fill once, the first time they are in view ------ */
    initBars() {
      this.querySelectorAll('[data-fnb-bars]').forEach(function (bars) {
        if (bars.classList.contains('is-in')) return;
        var show = function () { bars.classList.add('is-in'); };
        if (!('IntersectionObserver' in window) || prefersReducedMotion()) { show(); return; }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { show(); io.disconnect(); }
          });
        }, { threshold: 0.35 });
        io.observe(bars);
      });
    }

    /* ---- nutrition pop-up ------------------------------------------------- */
    initModals() {
      var self = this;
      this.querySelectorAll('[data-fnb-nutri-open]').forEach(function (openBtn) {
        var el = document.getElementById(openBtn.getAttribute('aria-controls'));
        if (!el) return;
        var card = el.querySelector('.fnb-nutri__card');
        var close = el.querySelector('[data-fnb-nutri-close]');
        var home = el.parentNode;
        var scroller = el.querySelector('.fnb-nutri__scroll');

        /* The scrollbar is hidden, so a bottom fade (.has-more) shows while
           there is more content below and clears once the end is reached. */
        function updateMore() {
          if (!scroller) return;
          el.classList.toggle('has-more', scroller.scrollTop + scroller.clientHeight < scroller.scrollHeight - 4);
        }
        if (scroller) scroller.addEventListener('scroll', updateMore, { passive: true });
        window.addEventListener('resize', function () { if (el.classList.contains('is-open')) updateMore(); });

        function onKey(e) {
          if (e.key === 'Escape') { hide(); return; }
          if (e.key !== 'Tab') return;
          var items = Array.prototype.slice.call(card.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])'));
          if (!items.length) { e.preventDefault(); return; }
          var first = items[0], last = items[items.length - 1];
          if (!card.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
          else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
        function show() {
          if (scroller) scroller.scrollTop = 0;
          el.classList.add('is-open');
          el.setAttribute('aria-hidden', 'false');
          window.requestAnimationFrame(updateMore);
          var gap = window.innerWidth - document.documentElement.clientWidth;
          document.body.style.paddingRight = gap > 0 ? gap + 'px' : '';
          document.body.classList.add('fnb-lock');
          if (close) close.focus({ preventScroll: true });
          document.addEventListener('keydown', onKey);
        }
        function hide(silent) {
          if (!el.classList.contains('is-open')) return;
          el.classList.remove('is-open');
          el.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('fnb-lock');
          document.body.style.paddingRight = '';
          document.removeEventListener('keydown', onKey);
          if (silent !== true) openBtn.focus({ preventScroll: true });
        }

        openBtn.addEventListener('click', show);
        if (close) close.addEventListener('click', function () { hide(); });
        el.addEventListener('click', function (e) { if (!card.contains(e.target)) hide(); });
        self.modals.push({ el: el, home: home, show: show, hide: hide });
      });
    }

    /* ---- theme editor ----------------------------------------------------- */
    onBlockSelect(e) {
      var t = e.target;
      if (!t || !this.contains(t)) return;
      var details = t.querySelector ? t.querySelector('details.fnb-acc') : null;
      if (details) details.open = true;
      if (this.gallery && t.classList && t.classList.contains('fnb-th')) {
        var i = this.gallery.slides.indexOf(t);
        if (i > -1) this.gallery.show(i);
      }
    }

    /* ---- add to cart ------------------------------------------------------ */
    onSubmit(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var self = this;
      var form = this.form;
      var btn = form.querySelector('[data-fnb-atc]');
      var err = form.querySelector('[data-fnb-error]');
      if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
      if (err) err.hidden = true;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      var after = form.getAttribute('data-after') || 'drawer';
      var root = routeRoot();
      var handedOff = false;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (res) {
          /* Anything other than a JSON cart response (Shopify's "verifying your
             connection" check, a rate limit, a proxy error page) cannot be read
             here. Hand over to a normal form post, which the browser can complete:
             the shopper lands on the cart with the same variant, quantity and
             selling plan, instead of seeing an unreadable error. */
          if ((res.headers.get('content-type') || '').indexOf('json') === -1) {
            handedOff = true;
            HTMLFormElement.prototype.submit.call(form);
            return null;
          }
          return res.json().then(function (body) {
            if (!res.ok || body.status) throw new Error(body.description || body.message || 'This item could not be added to your cart.');
            return body;
          });
        })
        .then(function (item) {
          if (handedOff) return null;
          if (after === 'cart') {
            window.location.href = self.data.cartUrl || root + 'cart';
            return null;
          }
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('fnb:cart-added', { detail: { item: item, cart: cart } }));
              if (after === 'drawer') return self.openDrawer();
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              self.flashAdded(btn);
              return null;
            });
        })
        .catch(function (error) {
          if (err) {
            err.textContent = error.message;
            err.hidden = false;
          }
        })
        .then(function () {
          if (handedOff) return;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        });
    }

    /* Theme cart drawer: re-render it from the server, then open it. */
    openDrawer() {
      var drawer = document.getElementById('cart-drawer');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (drawer && typeof drawer.show === 'function') drawer.show();
      else window.location.href = this.data.cartUrl || routeRoot() + 'cart';
      return null;
    }

    flashAdded(btn) {
      var label = btn.querySelector('[data-fnb-atc-label]');
      var text = btn.getAttribute('data-added');
      if (!label || !text) return;
      var self = this;
      btn.classList.add('is-added');
      label.textContent = text;
      clearTimeout(this.addedTimer);
      this.addedTimer = setTimeout(function () {
        btn.classList.remove('is-added');
        self.render();
      }, 1800);
    }
  }

  window.customElements.define('fn-buy-zone', FnBuyZone);
})();
